import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MarginIconBox = styled.span.attrs(({
  lg, theme, noborder, unselected,
}) => ({
  style: {
    fontSize: lg ? '16px' : '12px',
    lineHeight: lg ? '' : '12px',
    color: unselected ? theme.fontColor : theme.highlight,
    border: noborder ? 'none' : `solid 1px ${theme.activeBorder}`,
  },
}))`
  position: relative;
  display: inline-block;
  border-radius: 3px;
  width: 14px;
  height: 14px;
  text-align: center;
`;

const MarginIcon = props => (
  <MarginIconBox {...props}>{props.children || '5x'}</MarginIconBox>
);
MarginIcon.propTypes = {
  lg: PropTypes.bool,
  noborder: PropTypes.bool,
  unselected: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
};

export default MarginIcon;
